export default class TooltipFunction {
    static init(): void {
        const triggers = document.querySelectorAll('.js-tooltip-trigger');

        if (triggers.length === 0) {
            return;
        }

        triggers.forEach((trigger) => {
            const tooltip = new (window as any).bootstrap.Tooltip(trigger, {
                delay: { show: 200, hide: 0 },
            });
            let hideTimeout: NodeJS.Timeout | null = null;
            let tooltipElement: Element | null = null;
            let isOverTrigger = false;
            let isOverTooltip = false;

            const scheduleHide = () => {
                if (hideTimeout) clearTimeout(hideTimeout);
                hideTimeout = setTimeout(() => {
                    if (!isOverTrigger && !isOverTooltip) {
                        tooltip?.hide();
                    }
                }, 150);
            };

            const handleTriggerMouseEnter = () => {
                isOverTrigger = true;
                if (hideTimeout) clearTimeout(hideTimeout);
                tooltip.show();
            };

            const handleTriggerMouseLeave = () => {
                isOverTrigger = false;
                scheduleHide();
            };

            const handleTooltipMouseEnter = () => {
                isOverTooltip = true;
                if (hideTimeout) clearTimeout(hideTimeout);
            };

            const handleTooltipMouseLeave = () => {
                isOverTooltip = false;
                scheduleHide();
            };

            trigger.addEventListener('mouseenter', handleTriggerMouseEnter);
            trigger.addEventListener('mouseleave', handleTriggerMouseLeave);

            trigger.addEventListener('shown.bs.tooltip', () => {
                tooltipElement = document.querySelector('.tooltip.show');
                if (tooltipElement) {
                    (tooltipElement as HTMLElement).style.pointerEvents = 'auto';
                    if (!(tooltipElement as any).hasListener) {
                        tooltipElement.addEventListener('mouseenter', handleTooltipMouseEnter);
                        tooltipElement.addEventListener('mouseleave', handleTooltipMouseLeave);
                        (tooltipElement as any).hasListener = true;
                    }
                }
            });

            trigger.addEventListener('hidden.bs.tooltip', () => {
                if (tooltipElement && (tooltipElement as any).hasListener) {
                    tooltipElement.removeEventListener('mouseenter', handleTooltipMouseEnter);
                    tooltipElement.removeEventListener('mouseleave', handleTooltipMouseLeave);
                    (tooltipElement as any).hasListener = false;
                    tooltipElement = null;
                }
            });
        });
    }
}
